import React, { useState } from 'react';

const SIZES = [
  { label:'Petit',  size:150 },
  { label:'Moyen',  size:300 },
  { label:'Grand',  size:500 },
];

export default function QRGeneratorSection() {
  const [text,    setText]    = useState('');
  const [qrData,  setQrData]  = useState('');
  const [size,    setSize]    = useState(300);
  const [fgColor, setFgColor] = useState('000000');
  const [bgColor, setBgColor] = useState('ffffff');
  const [copied,  setCopied]  = useState(false);

  const qrUrl = qrData
    ? `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(qrData)}&color=${fgColor}&bgcolor=${bgColor}&format=png&ecc=M&margin=1`
    : null;

  const generate = () => { if (text.trim()) setQrData(text.trim()); };

  const download = async () => {
    if (!qrUrl) return;
    try {
      const r    = await fetch(qrUrl);
      const blob = await r.blob();
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement('a');
      a.href = url;
      a.download = `qrcode-${Date.now()}.png`;
      a.click();
      URL.revokeObjectURL(url);
    } catch {}
  };

  const copyLink = () => {
    if (!qrUrl) return;
    navigator.clipboard.writeText(qrUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };

  const s = {
    label:  { fontSize:'0.65rem', color:'#555', fontWeight:700, letterSpacing:'0.12em', textTransform:'uppercase', marginBottom:7, display:'block' },
    btn:    { background:'#C8FF00', color:'#000', border:'none', padding:'11px 22px', borderRadius:10, fontWeight:800, fontSize:'0.86rem', cursor:'pointer' },
    outBtn: { background:'transparent', border:'1px solid rgba(255,255,255,0.1)', color:'#888', padding:'10px 18px', borderRadius:10, fontWeight:600, fontSize:'0.84rem', cursor:'pointer' },
  };

  return (
    <div style={{ animation:'fadeIn 0.3s ease' }}>
      <div style={{ marginBottom:32 }}>
        <div style={{ fontSize:'0.65rem', color:'#555', fontWeight:700, letterSpacing:'0.12em', textTransform:'uppercase', marginBottom:6 }}>Outil gratuit</div>
        <h2 style={{ fontSize:'1.6rem', fontWeight:900, color:'#EAEAEA', letterSpacing:'-0.03em', marginBottom:4 }}>Générateur de QR Code</h2>
        <p style={{ color:'#555', fontSize:'0.85rem' }}>URL, texte, carte de visite — téléchargement PNG gratuit.</p>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'1fr 240px', gap:28, alignItems:'start' }}>
        {/* LEFT */}
        <div>
          <div style={{ marginBottom:18 }}>
            <span style={s.label}>URL ou texte</span>
            <textarea
              value={text}
              onChange={e => setText(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && !e.shiftKey && (e.preventDefault(), generate())}
              placeholder="https://axispme.ca  ou  514-914-9110  ou  votre texte…"
              rows={3}
              style={{ width:'100%', background:'#111', border:'1px solid rgba(255,255,255,0.1)', borderRadius:10, padding:'12px 14px', color:'#EAEAEA', fontSize:'0.88rem', outline:'none', resize:'vertical', fontFamily:'inherit' }}
            />
          </div>

          {/* SIZE */}
          <div style={{ marginBottom:18 }}>
            <span style={s.label}>Taille</span>
            <div style={{ display:'flex', gap:8 }}>
              {SIZES.map(sz => (
                <button key={sz.size} onClick={() => setSize(sz.size)} style={{
                  padding:'8px 16px', borderRadius:8,
                  border:`1px solid ${size === sz.size ? 'rgba(200,255,0,0.35)' : 'rgba(255,255,255,0.07)'}`,
                  background: size === sz.size ? 'rgba(200,255,0,0.07)' : 'transparent',
                  color: size === sz.size ? '#C8FF00' : '#666',
                  fontWeight:700, fontSize:'0.8rem', cursor:'pointer',
                }}>
                  {sz.label} <span style={{ color:'#444', fontWeight:400 }}>({sz.size}px)</span>
                </button>
              ))}
            </div>
          </div>

          {/* COLORS */}
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:24 }}>
            {[
              { label:'Couleur du code', val:fgColor, set:setFgColor },
              { label:'Couleur du fond', val:bgColor, set:setBgColor },
            ].map(c => (
              <div key={c.label}>
                <span style={s.label}>{c.label}</span>
                <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                  <input
                    type="color" value={'#' + c.val}
                    onChange={e => c.set(e.target.value.replace('#', ''))}
                    style={{ width:36, height:36, padding:2, background:'transparent', border:'1px solid rgba(255,255,255,0.1)', borderRadius:8, cursor:'pointer' }}
                  />
                  <span style={{ color:'#555', fontSize:'0.8rem', fontFamily:'monospace' }}>#{c.val.toUpperCase()}</span>
                </div>
              </div>
            ))}
          </div>

          <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
            <button style={{ ...s.btn, opacity: text.trim() ? 1 : 0.4 }} disabled={!text.trim()} onClick={generate}>Générer</button>
            {qrUrl && <button style={s.outBtn} onClick={download}>⬇ Télécharger PNG</button>}
            {qrUrl && <button style={s.outBtn} onClick={copyLink}>{copied ? '✓ Copié !' : '⎘ Copier le lien'}</button>}
          </div>
        </div>

        {/* RIGHT — PREVIEW */}
        <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:10 }}>
          <span style={s.label}>Aperçu</span>
          {qrUrl ? (
            <>
              <div style={{ background:'#fff', borderRadius:12, padding:10, boxShadow:'0 0 0 1px rgba(255,255,255,0.04)' }}>
                <img src={qrUrl} alt="QR Code" style={{ width:196, height:196, display:'block' }} />
              </div>
              <div style={{ fontSize:'0.7rem', color:'#444', textAlign:'center' }}>{size}×{size} px · PNG</div>
            </>
          ) : (
            <div style={{
              width:216, height:216,
              background:'#111', border:'1px solid rgba(255,255,255,0.06)', borderRadius:12,
              display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:8,
            }}>
              <svg width="44" height="44" fill="none" stroke="#2a2a2a" strokeWidth="1.4" viewBox="0 0 24 24">
                <rect x="3" y="3" width="5" height="5" rx="1"/>
                <rect x="16" y="3" width="5" height="5" rx="1"/>
                <rect x="3" y="16" width="5" height="5" rx="1"/>
                <path d="M21 16h-5v5M16 16v-5h5"/>
                <path d="M10 3h1M10 10h1M3 10h1M10 16h1"/>
              </svg>
              <span style={{ color:'#2a2a2a', fontSize:'0.72rem' }}>Aperçu ici</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
